/**
 * @module lib/commercial/keytar/anonymous
 */
import MeteredWall from "lib/commercial/keytar/MeteredWall";
import template from "./template";
import { WALL_TYPES } from "lib/commercial/keytar/WallAnalyticsSchema";
import consts from "lib/consts";
import { roles } from "lib/identity/api";
import isNil from "lodash/isNil";
import logger from "utils/logger";
import { processObjectMethods } from "../helpers";

const name = "anonymousRegwall";
const debugTag = `[KEYTAR] ${name}`;

const rules = [{
  /** @returns {Boolean} true when access is allowed for user */
  accessAllowed({ customer, paywallStatus, meter }) {
    if (isNil(customer)) {
      return false;
    }
    const allowed = {
      isReg: () => customer.canAccessRegisteredContent,
      isBlue: () => paywallStatus === "blue",
      isYellow: () => paywallStatus === "yellow" && !meter.full
    };
    const access = processObjectMethods(allowed);
    logger.info(`${debugTag} access:`, access, allowed);
    return access;
  },
  /** @returns {Boolean} true when wall should be used for article page */
  matcher({ paywallStatus, customer }) {
    return ["yellow", "blue"].includes(paywallStatus)
      && customer.hasRoleId(roles.anonymous.id);
  },
  /** @type {String} */
  name: name
}];

const props = {
  rules,
  featureFlagName: `${name}Enabled`, // defined in environment-variables.jsp
  template,
  meterKey: "wall.subscriber", // shared with other walls
  meterLimit: consts.KEYTAR.REGWALL.LIMIT, // page-views
  meterRenew: consts.KEYTAR.REGWALL.RENEW // days
};

export default new MeteredWall("regwall", WALL_TYPES.REGWALL_METERED, props);
